module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issue-status-icons"
  }, [_vm._l((_vm.issues), function(issue, index) {
    return (index < 3) ? _c('span', [_c('img', {
      staticClass: "issue-status-icons__icon",
      attrs: {
        "src": _vm.getIcon(issue.issueType)
      },
      on: {
        "mouseover": function($event) {
          _vm.currentPopover = index
        },
        "mouseleave": function($event) {
          _vm.currentPopover = null
        }
      }
    }), _vm._v(" "), (issue.serviceProvider != null) ? _c('div', {
      staticClass: "issue-status-icons__status-badge",
      class: issue.status
    }) : _vm._e(), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade",
        "mode": "in-out"
      }
    }, [(_vm.currentPopover == index) ? _c('div', {
      staticClass: "popover"
    }, [_c('div', {
      staticClass: "popover__status-badge",
      class: issue.status
    }), _vm._v(" "), _c('span', {
      staticClass: "popover__status-text"
    }, [_vm._v(_vm._s(_vm.formatStatus(issue.status)))])]) : _vm._e()])], 1) : _vm._e()
  }), _vm._v(" "), ((_vm.issues.length - 1) > 2) ? _c('span', {
    staticClass: "issue-status-icons__more-text font-primary--bold"
  }, [_vm._v(" + " + _vm._s(_vm.issues.length - 3) + " more")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d3d8142","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/IssueStatusIcons/IssueStatusIcons.vue
// module id = 559
// module chunks = 1